/**
 * Lightweight className merger.
 * Filters falsy values and joins with a space.
 *
 * Usage:
 *   cn("base-class", isActive && "active", className)
 *
 * For projects using tailwind-merge, swap the body with:
 *   import { twMerge } from "tailwind-merge"
 *   return twMerge(clsx(...inputs))
 */
export function cn(
  ...inputs: (string | boolean | null | undefined)[]
): string {
  return inputs.filter(Boolean).join(" ");
}